import { toast } from 'react-toastify'

const defaultOptions = {
  position: 'top-right',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
}

export const notify = {
  success: (message, options = {}) => {
    toast.success(message, {
      ...defaultOptions,
      ...options,
      className: 'toast-success',
    })
  },

  error: (message, options = {}) => {
    toast.error(message, {
      ...defaultOptions,
      ...options,
      className: 'toast-error',
    })
  },

  info: (message, options = {}) => {
    toast.info(message, {
      ...defaultOptions,
      ...options,
      className: 'toast-info',
    })
  },

  warning: (message, options = {}) => {
    toast.warning(message, {
      ...defaultOptions,
      ...options,
      className: 'toast-warning',
    })
  },

  promise: (promise, messages, options = {}) => {
    return toast.promise(
      promise,
      {
        pending: messages.pending || 'Processing...',
        success: messages.success || 'Success!',
        error: messages.error || 'Something went wrong',
      },
      {
        ...defaultOptions,
        ...options,
      }
    )
  },
}
